<template>
<div v-if="enableTracking" id="trackingMap" class="talk-panel">
    <div v-if="appData.loaded">
        <div v-if="!appData.enableTrackingOption && !appData.enableTrackingTrial" class="itemheader" height="100%">
            <div style="text-align:center;padding-top: 30px;">
                <span v-if="appData.planType === 0" v-t="'message.info_need_purchase_option'"/>
                <span v-else v-t="'message.info_need_purchase_enterprise_plan'"/>
            </div>
        </div>
        <div v-else>
            <multipane class="vertical-panes" layout="vertical">
                <div id="left-pane" class="pane" :style="{ width: '25%', maxWidth: '100%' }">
                    <div class="inner-panel">
                        <div class="objectTree" v-if="showTree">
                            <objectTree v-bind:initialData="initialData" @on-selectnode="handleOnSelectNode" @onInitGroup="handleOnInitGroup" ref="objectTree" :trackingMap="true" :showSearchObject="false">
                            </objectTree>
                        </div>
                    </div>
                </div>
                <multipane-resizer></multipane-resizer>
                <div class="pane" :style="{ flexGrow: 1 }">
                    <div style="height:100%">
                        <div class="handle" v-on:click="onClick($event)"><i class="icon" v-bind:class="[isRight ? iconLeft : iconRight]"></i></div>
                        <div id="maps" v-if="mapAvailable">
                            <googleMap :appData="appData" :selectedNode="selectedNode" ref="GoogleMap" @showMarkerIconList="showMarkerIconList">
                            </googleMap>
                        </div>
                    </div>
                </div>
            </multipane>
        </div>
    </div>
    <mapMarker v-if="showMapMarker" :mapMarkerParam=showMapMarkerParam @change="changeMarkerIcon" @cancel="showMapMarker=false"></mapMarker>
</div>
<div v-else>
    <div style="text-align:center;padding-top:40px">
        {{ getNoticeOfDisableOption() }}
    </div>
</div>
</template>

<script>
import Vue from 'vue'
import googleMap from './GoogleMap'
import mapMarker from './MapMarker'
import server from "./ServerApi.js";
import ObjectTree from "./ObjectTreeForMap.vue"
import constants from './constants.js';
import commonUtil from './commonutil.js';
import VueCookie from "vue-cookie";
import { Multipane, MultipaneResizer } from "vue-multipane";

export default {
    props: ['appData'],
    components: {
        'objectTree': ObjectTree,
        'googleMap': googleMap,
        'mapMarker': mapMarker,
        'multipane': Multipane,
        'multipane-resizer': MultipaneResizer
    },
    data() {
        return {
            enableTracking: true,
            showMapMarker: false,
            showMapMarkerParam: {
                displayName: null,
                iconUrl: null
            },
            selectedNode: null,
            showTree: true,
            isOpen: true,
            isRight: true,
            iconRight: "el-icon-arrow-right",
            iconLeft: "el-icon-arrow-left",
            mapAvailable: false,
            initialData: [],
            savedLeftPaneWidth: null
        }
    },
    methods: {
        handleOnSelectNode(elnode) {
            if (this.selectedNode != null) {
                this.$refs.GoogleMap.handleChangeMarkerDisplayStatus(elnode.node);
            }
            this.selectedNode = elnode.node;
        },
        handleOnInitGroup(node) {
            this.selectedNode = node;
        },
        onClick: function(event) {
            let leftPaneElement = document.getElementById("left-pane");
            if (this.isOpen) {
                this.isOpen = false;
                this.isRight = false;
                this.savedLeftPaneWidth = leftPaneElement.style.width;
                leftPaneElement.style.width = "0%";
            } else {
                this.isOpen = true;
                this.isRight = true;
                leftPaneElement.style.width = this.savedLeftPaneWidth;
            }
            var this_2 = this;
            setTimeout(function() {
                this_2.$refs['GoogleMap'].$refs['scale'].setResize();
            }, 200);
        },
        mapAccess: function() {
            if (this.appData.tenantList.length < 1) {
                return;
            }
            if(this.appData.loginUserObjectId == 0 ){
              return;
            }
            var endpoint = '/accessMap';
            var input = {
                tenantId: this.appData.tenantList[0].tenantId,
                userId: this.appData.loginUserObjectId,
            }
            let self = this;
            server.post(endpoint, input)
                .then((res) => {
                    self.mapAvailable = true;
                });
        },
        showMarkerIconList(displayName,iconUrl) {
            this.showMapMarkerParam.displayName = displayName;
            this.showMapMarkerParam.iconUrl = iconUrl == null ? "" : iconUrl;
            this.showMapMarker = true;
        },
        changeMarkerIcon(iconUrl) {
            this.showMapMarker = false;
            this.$refs.GoogleMap.changeMarkerIcon(iconUrl);
        },
        getNoticeOfDisableOption() {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.getMessageText(this.$i18n,"error_need_location_tracking_option");
            } else {
                return commonUtil.getMessageText(this.$i18n,"error_not_support_option_by_this_plan");
            }
        }
    },
    watch: {
        'appData.tenantList' (newVal) {
            if (this.initialData.length == 0) {
                this.initialData.push({
                    tenantId: this.appData.tenantList[0].tenantId,
                    name: "ROOT-NODE",
                    id: 1,
                    label: "ROOT-NODE",
                    type: 0,
                    isLeaf: false
                });
            }
            this.showTree = false;
            this.$nextTick(() => {
                this.showTree = true;
            });
        },
        'appData.loginUserObjectId' (newVal) {
            this.$nextTick(() => {
              this.mapAccess();
            });
        },
        'appData.loaded' (newVal) {
            if (this.appData.loaded) {
                if (!commonUtil.isEnableOption(this.appData, constants.LICENSE_TRACKING)) {
                    this.enableTracking = false;
                }
            }
        },
    },
    created() {
        if (this.appData.tenantList.length > 0) {
            this.initialData.push({
                tenantId: this.appData.tenantList[0].tenantId,
                name: "ROOT-NODE",
                id: 1,
                label: "ROOT-NODE",
                type: 0,
                isLeaf: false
            });
            this.showTree = true;
        }
        if (this.appData.loaded) {
            if (!commonUtil.isEnableOption(this.appData, constants.LICENSE_TRACKING)) {
                this.enableTracking = false;
            }
        }
    },
    mounted() {
        let mapElement = document.getElementById("trackingMap");
        let script = document.createElement('script');
        script.src = "https://maps.googleapis.com/maps/api/js" +
            "?key=" + commonUtil.getGoogleMapApiKey() +
            "&language=" + commonUtil.getBrowserLanguage(VueCookie.get("aldioweb-lang")) +
            "&region=" + this.appData.countryCodeAlpha2;
        script.defer = true;                                    // need defer attribute to avoid the script error on IE
        mapElement.appendChild(script);
        if (this.appData.loginUserObjectId != 0) {
            this.mapAccess();
        }
    }
}
</script>

<style>
.list {
    width: 0%;
    transition: 0.15s;
}

.list.isOpen {
    width: 20%;

}
.mapArea {
    width: 80%;
}

.mapArea.full {
    width: 100%;

}

#maps {
    height: 100%;
    background-color: #fff;
}

table {
    border-collapse: collapse;

}

tr {
    position: relative;
}

td {
    position: relative;
}

tr.itemheader {
    border-top: 1px solid #eeeeee;
}

.talk-panel {
    position: relative;
    height: 100%;
    background-color: #ffffff;
}

.inner-panel {
    position: relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #ffffff;
}

.scrollable {
    overflow: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

select {
    height: 40px;
}

.search {
    width: 100%;
    background-color: #ecf1fa;
    display: table;
}

.serarch-contents {
    display: table-cell;
    vertical-align: middle;
}

.date-picker {
    display: inline-block;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.time-picker {
    display: inline-block;
    padding-left: 20px;
}

.display-target {
    display: inline-block;
    padding-left: 20px;
}

.display-tags {
    display: inline-block;
}

.p2p-tags {
    display: inline-block;
}

.peer-user {
    display: inline-block;
}

.selected-tag {
    display: inline-block;
    border: 1px solid;
    border-radius: 30px;
    border-color: #5171cb;
    background-color: #ffffff;
    color: #5171cb;
    margin: 5px;
    padding: 6px;
    padding-left: 10px;
}

.selected-tag>.closeTag {
    cursor: pointer;
    border-radius: 4px;
    margin: 4px;
}

.selected-tag>.closeTag:active {
    background-color: gray;
}

.date-picker>>>.el-input__inner {
    background-image: url('../assets/icon_calendar.svg');
    background-repeat: no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 35px;
}

.time-picker>>>.el-input__inner {
    background-image: url('../assets/icon_clock.svg');
    background-repeat: no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 35px;
}

.overlayarea {
    height: 100%;
    width: 0px;
    right: 100%;
    left: auto;
    top: 0px;
    float: left;

}

.handle {
    position: absolute;
    top: calc(50% - 40px);
    left: 10px;
    width: 30px;
    height: 80px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;

}

.vertical-panes {
    width: 100%;
    height: 100vh;
    border: 1px solid #eee;
}
.vertical-panes > .pane {
    text-align: left;
    padding: 0px;
    overflow: hidden;
}
.vertical-panes > .pane ~ .pane {
    border-left: 1px solid #eee;
}
</style>
